import { gql } from '@provision/graphql-client';

export const NOTIFICATION_FRAGMENT = gql`
  fragment NotificationFields on Notification {
    id
    userId
    notificationId
    notificationChannelId
    notificationEventId
    entity
    entityId
    status
    title
    subject
    flowInitiatorEntity
    flowInitiatorEntityId
    payload
    createdAt
    updatedAt
  }
`;

export const NOTIFICATION_RELATION_FRAGMENT = gql`
  fragment NotificationRelations on Notification {
    id
    platformUserFlowInitiator {
      id
      firstName
      lastName
    }
    clientFlowInitiator {
      id
      firstName
      lastName
    }
  }
`;
